module.exports = __webpack_public_path__ + "img/chicoloapan.cfd1dd04.jpg";